(window as any).FastComponents = {
    ready: async (...names) => {
        await Promise.all(
            names.map((name) => customElements.whenDefined(name))
        );
        return names;
    },
};
